import React from 'react';
import './PricingPage.css';

const PricingPage = () => {
  const freeProjects = process.env.REACT_APP_FREE_PLAN_PROJECTS || '3';
  const freeAiRequests = process.env.REACT_APP_FREE_PLAN_AI_REQUESTS || '100';
  const proPlanPrice = process.env.REACT_APP_PRO_PLAN_PRICE || '19';
  const teamPlanPrice = process.env.REACT_APP_TEAM_PLAN_PRICE || '49';
  const discordUrl = process.env.REACT_APP_DISCORD_URL || '#';

  const plans = [
    {
      name: 'Free',
      price: '0',
      period: 'forever',
      description: 'Perfect for individual developers getting started.',
      color: 'pricing__card--free',
      badge: null,
      features: [
        `Up to ${freeProjects} projects`,
        `${freeAiRequests} AI requests / day`,
        'Basic code completion',
        'Syntax highlighting (30+ languages)',
        'Git integration',
        'Community support',
      ],
      cta: 'Get Started Free',
      ctaClass: 'pricing__cta--outline',
    },
    {
      name: 'Pro',
      price: proPlanPrice,
      period: 'per month',
      description: 'For professional developers who demand more power.',
      color: 'pricing__card--pro',
      badge: 'Most Popular',
      features: [
        'Unlimited projects',
        'Unlimited AI requests',
        'Advanced AI code generation',
        'AI code review & refactoring',
        'Real-time collaboration (2 users)',
        'Priority support',
        'Custom themes',
        'API access',
      ],
      cta: 'Start Pro Trial',
      ctaClass: 'pricing__cta--primary',
    },
    {
      name: 'Team',
      price: teamPlanPrice,
      period: 'per user / month',
      description: 'Built for teams that ship great software together.',
      color: 'pricing__card--team',
      badge: null,
      features: [
        'Everything in Pro',
        'Unlimited collaboration seats',
        'Team analytics dashboard',
        'SSO / SAML authentication',
        'Audit logs',
        'Dedicated account manager',
        'SLA guarantee (99.9%)',
        'On-premise deployment option',
      ],
      cta: 'Contact Sales',
      ctaClass: 'pricing__cta--outline',
    },
  ];

  return (
    <div className="pricing-page">
      {/* Hero */}
      <section className="pricing-page__hero">
        <div className="pricing-page__hero-bg" />
        <div className="pricing-page__container">
          <div className="pricing-page__badge">
            <span>💎</span> Simple, Transparent Pricing
          </div>
          <h1 className="pricing-page__title">
            Choose the plan that fits <br />
            <span className="pricing-page__title-gradient">your workflow</span>
          </h1>
          <p className="pricing-page__subtitle">
            Start free, scale as you grow. No hidden fees. Cancel anytime.
          </p>
        </div>
      </section>

      {/* Plans */}
      <section className="pricing-page__plans">
        <div className="pricing-page__container">
          <div className="pricing-page__grid">
            {plans.map((plan) => (
              <div key={plan.name} className={`pricing__card ${plan.color}`}>
                {plan.badge && (
                  <div className="pricing__badge">{plan.badge}</div>
                )}
                <div className="pricing__card-header">
                  <h3 className="pricing__plan-name">{plan.name}</h3>
                  <div className="pricing__price-row">
                    <span className="pricing__currency">$</span>
                    <span className="pricing__amount">{plan.price}</span>
                    <span className="pricing__period">/{plan.period}</span>
                  </div>
                  <p className="pricing__description">{plan.description}</p>
                </div>
                <ul className="pricing__features">
                  {plan.features.map((f) => (
                    <li key={f} className="pricing__feature">
                      <span className="pricing__check">✓</span>
                      {f}
                    </li>
                  ))}
                </ul>
                <button className={`pricing__cta ${plan.ctaClass}`}>
                  {plan.cta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="pricing-page__faq">
        <div className="pricing-page__container">
          <h2 className="pricing-page__faq-title">Frequently Asked Questions</h2>
          <div className="pricing-page__faq-grid">
            {[
              {
                q: 'Can I switch plans at any time?',
                a: 'Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.',
              },
              {
                q: 'Is there a free trial for Pro?',
                a: 'Absolutely! The Pro plan comes with a 14-day free trial, no credit card required.',
              },
              {
                q: 'What payment methods do you accept?',
                a: 'We accept all major credit cards (Visa, MasterCard, Amex) and PayPal.',
              },
              {
                q: 'Do you offer student discounts?',
                a: 'Yes! Students get 50% off any paid plan. Reach out via Discord to verify your status.',
              },
            ].map((item) => (
              <div key={item.q} className="pricing-page__faq-item">
                <h4 className="pricing-page__faq-q">{item.q}</h4>
                <p className="pricing-page__faq-a">{item.a}</p>
              </div>
            ))}
          </div>
          <div className="pricing-page__cta-strip">
            <p>Still have questions?</p>
            <a href={discordUrl} target="_blank" rel="noreferrer" className="pricing-page__discord-btn">
              💬 Join our Discord
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PricingPage;